import angular from 'angular';
import searchInputField from './searchInputField';

export default angular
  .module('component.searchInputField', [])
  .component('searchInputField', searchInputField).name;
